import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';

import 'style/layout/Table.css';

const BasicTable = ({
  columns,
  data,
  getRowClasses,
  setSelectedRow,
  keyField,
}: {
  columns: any;
  data: any;
  // Classes of a row in addition to row-body, e.g. for a line between groups
  getRowClasses?: (row: any, rowIndex: number) => string;
  setSelectedRow?: any;
  keyField: any;
}): JSX.Element | null => {
  const rowEvents = {
    onClick: (e: any, row: any, rowIndex: any) => {
      if (setSelectedRow !== undefined) {
        setSelectedRow(rowIndex);
      }
    },
  };
  return (
    <div className="basic-table">
      <BootstrapTable
        keyField={keyField}
        headerWrapperClasses="table-header"
        bodyClasses="table-body"
        rowClasses={
          getRowClasses === undefined
            ? 'row-body'
            : (row: any, rowIndex: number) =>
                `row-body ${getRowClasses(row, rowIndex)}`.trim()
        }
        bordered={false}
        columns={columns}
        data={data || []}
        remote
        rowEvents={rowEvents}
      />
    </div>
  );
};

export default BasicTable;
